import { Tag } from "antd";

export const returnProperMachineTag = (machine) => {
  switch (machine) {
    case "Tape":
      return <Tag color="#a0d911">Tape</Tag>;
    case "Arsoma":
      return <Tag color="#1677ff">Arsoma</Tag>;
    case "Cutter":
      return <Tag color="#faad14">Cutter</Tag>;
    case "Viva":
      return <Tag color="#13c2c2">Viva</Tag>;
    default:
      return <Tag>Unknown</Tag>;
  }
};
